import * as React from "react"
import { App } from "./app"
import { ArticleGW } from "./ArticleGW"
import { PADebug } from "./PADebug"

///////////////   ArticleViewGW  ////////////////
export interface ArticleViewVm  {
    initialUrl: string
    initialNobb: string
    width: string
    height: string
    app: App
}

export interface ArticleStateVm {
}

/** The ArticleViewGW is the controlling class for the central-right area, where articles are
 *  displayed as you select an item withing the treeview to the right (or shows the list of favorites
 *  in case you clicked the favorites button at the top) On render it only displays a list of articles.
 *  The corresponding header (with column titles) is rendered within App.render(), the rendering of
 *  its articles is mainly located within BDKalkCore and within AricleItemGW (see below) which draws
 *  and handles the interactions with an article in the list.  */
export class ArticleViewGW extends React.Component<ArticleViewVm, ArticleStateVm> {
    state: ArticleStateVm = {}

    // Sets the core's reference back to this view on initiation
    componentWillMount() {
        this.props.app.GetCore().ConnectArticleView(this)
    }

    render() {
        /* A few states in app has to be set to correct values before the ArticleView can be fully rendered, and these states
           are somewhat depending on the following calculation, which will cause the rendering process to restart as these
           states are set in App, but at the second attempt of rendering ArticleView, these values are allready being correct
           and won't trigger any additional state shift, thus the render will run uninterruptedly until complete. */
        PADebug.Log("ArticleViewGW.render - at start")

        var core = this.props.app.GetCore()
        var articlesToBedisplayed: Array<ArticleGW> = new Array<ArticleGW>() // This will hold the group of displayed articles, with a set max amount for optimization purposes

        if (this.props.app.state.DisplayMode == this.props.app.DMode.Favorites) {
            // return this.props.app.GetCore().RenderFavorites()

            const buffer = core.GetFavorites()

            if (buffer == null) {
                return <div></div>
            }

            var startPoint = (this.props.app.state.resultGroup * this.props.app.state.resultGroupLength)

            for (var i = 0, j = startPoint; i < this.props.app.state.resultGroupLength; i++ , j++) {
                if (j < buffer.length) {
                    articlesToBedisplayed.push(buffer[j])
                }
                else {
                    break
                }
            }

            return <div>{core.RenderArticles(articlesToBedisplayed, "favorites")}</div>
        }

        if (this.props.app.state.DisplayMode == this.props.app.DMode.Loading) {
            this.props.app.GetCore().SetLastSelectedNobbGroup(this.props.app.state.articlesNobb)
            return <div style={{position:"relative", top:"12px",  left:"20px"}}>Innhenter data...</div>
        }
        
        if (this.props.app.state.DisplayMode == this.props.app.DMode.SearchResult) {
            const buffer = core.GetDisplayedArticles()
            
            if (buffer == null) {
                return <div></div>
            }

            var startPoint = (this.props.app.state.resultGroup * this.props.app.state.resultGroupLength)

            for (var i = 0, j = startPoint; i < this.props.app.state.resultGroupLength; i++ , j++) {
                if (j < buffer.length) {
                    articlesToBedisplayed.push(buffer[j])
                }
                else {
                    break
                }
            }

            return <div>{core.RenderArticles(articlesToBedisplayed, "search")}</div>
        }

        // This is a selection from the nobb tree to the left (since all alternate displaymodes have been checked) 
        const nobbGroup = this.props.app.state.articlesNobb
        PADebug.Log("ArticleViewGW.render - before rendering articles by group:" + nobbGroup)
        var buffer = core.GetArticlesByGroup(nobbGroup)
        
        
        // In case of a group ID of "" the buffer might be empty (null) and in this case an empty div is returned
        if (buffer == null) {
            return <div></div>
        }

        // The following will cause a second render if app states are old and needs to be renewed
        if (this.props.app.state.resultTotalArticles != buffer.length) {
            this.props.app.GetCore().SetIncomingResultLength(buffer.length)
            setTimeout(this.props.app.GetCore().UpdateAppStateTotalArticles.bind(this.props.app.GetCore()), 60)
        }

        var startPoint = (this.props.app.state.resultGroup * this.props.app.state.resultGroupLength)

        for (var i = 0, j = startPoint; i < this.props.app.state.resultGroupLength; i++ , j++) {
            if (j < buffer.length) {
                articlesToBedisplayed.push(buffer[j])
            }
            else {
                break
            }
        }
            
        return <div>{core.RenderArticles(articlesToBedisplayed, "nobb")}</div>
    }
}



// WEBPACK FOOTER //
// ./client/view/ArticleViewGW.tsx